import { render, staticRenderFns } from "./koejakso-view-kouluttaja.vue?vue&type=template&id=294cbdd6&"
import script from "./koejakso-view-kouluttaja.vue?vue&type=script&lang=ts&"
export * from "./koejakso-view-kouluttaja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports